import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import DotsSvg from 'images/v5/icons/dots-vertical.svg';
import PlanIcon from 'images/v5/icons/file-check-01.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Pie from 'layout/atoms/Pie';
import { openModal, selectOrderCollectionsTimelinePeriod } from 'store/layoutSlice';
import styles from './TimelineEvent.module.scss';
function TimelineEvent({ item, getItemProps }) {
    var _a;
    const { t } = useTranslation(['orders']);
    const dispatch = useDispatch();
    const timelinePeriod = useSelector(selectOrderCollectionsTimelinePeriod);
    const [isActive, setIsActive] = useState(false);
    const wrapRef = useRef(null);
    const eventTimelinePeriod = item.timelinePeriod || timelinePeriod;
    const dayWidthMap = { day: 60, week: 30, month: 15 };
    const dayWidth = dayWidthMap[eventTimelinePeriod] || dayWidthMap.week;
    const delayBarDays = (_a = item.daysUntilNextEvent) !== null && _a !== void 0 ? _a : item.delayDays;
    const hasDelayBar = delayBarDays !== null && delayBarDays !== undefined;
    const isPlanningApproved = item.menuType === 'planning-approved';
    const isPlanningVirtual = item.menuType === 'planning-virtual';
    const openProductionDetailsModal = (mode) => dispatch(openModal({
        name: 'productionApprovalDetails',
        data: {
            specificationName: item.specificationName,
            manufacturerName: item.manufacturerName,
            manufacturerEmployees: item.manufacturerEmployees,
            manufacturerId: item.manufacturerId,
            manufacturerNonWorkingDays: item.manufacturerNonWorkingDays,
            productionTimeMinutes: item.productionTimeMinutes,
            productionStartDate: item.productionStartDate,
            orderId: item.orderId,
            specificationId: item.specificationId,
            totalProductionTimeMinutes: item.totalProductionTimeMinutes,
            virtualEndDate: item.virtualEndDate,
            sumOfModelQuantities: item.sumOfModelQuantities,
            mode,
        },
    }));
    const handleClick = () => {
        if (isPlanningVirtual) {
            return;
        }
        if (item.menuType === 'planning-approved') {
            openProductionDetailsModal('preview');
            return;
        }
        setIsActive(true);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapRef.current && !wrapRef.current.contains(event.target)) {
                setIsActive(false);
            }
        };
        if (isActive) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isActive]);
    const menuItems = (() => {
        if (item.menuType === 'planning') {
            return [
                {
                    label: t('orders:planning_approve_production'),
                    icon: React.createElement(PlanIcon, null),
                    onClick: () => openProductionDetailsModal('approval'),
                },
            ];
        }
        if (item.menuType === 'planning-approved' || item.menuType === 'planning-virtual') {
            return [];
        }
        return [
            {
                label: t('plan'),
                icon: React.createElement(PlanIcon, null),
                onClick: () => dispatch(openModal({
                    name: 'deliveryPlanner',
                    data: { id: item.id, componentVariantId: item.componentVariantId },
                })),
            },
        ];
    })();
    const itemInteractionProps = isPlanningVirtual
        ? {}
        : {
            onClick: handleClick,
            onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick();
                }
            },
            role: 'button',
            tabIndex: 0,
        };
    return (React.createElement("div", Object.assign({ ref: wrapRef }, getItemProps(), itemInteractionProps, { className: classNames(styles.wrap, styles[item.status], {
            [styles.active]: isActive,
            [styles.virtual]: isPlanningVirtual,
        }), title: item.simpleTitle || item.title, style: { width: hasDelayBar ? dayWidth * (delayBarDays + 1) : 'fit-content' } }),
        item.delayDays && React.createElement("div", { className: styles.delayBg }),
        React.createElement("div", { className: styles.content },
            item.status === 'error' && (React.createElement(Pie, { value: item.quantity, total: item.ordered, color: "#f26464" })),
            item.status === 'in-progress' && item.plannedDate && (React.createElement(Pie, { value: item.quantity, total: item.ordered })),
            item.status === 'waiting' && (React.createElement("span", { className: styles.markerTitle }, t('WAITING_FOR_ORDER'))),
            isPlanningApproved && (item.simpleTitle || item.title) && (React.createElement("span", { className: styles.markerTitle }, item.simpleTitle || item.title)),
            item.status === 'done' && !isPlanningApproved && (React.createElement("span", { className: styles.markerTitle },
                t('DELIVERED'),
                " - ",
                item.title)),
            !item.status && (item.simpleTitle || item.title) && (React.createElement("span", { className: styles.markerTitle }, item.simpleTitle || item.title)),
            menuItems.length > 0 && (React.createElement(Dropdown, { trigger: React.createElement(Button, { size: "xs", theme: "ghost", shape: "rounded" },
                    React.createElement(DotsSvg, null)) }, menuItems.map((menuItem) => (React.createElement(Button, { key: menuItem.label, theme: "ghost", align: "left", leftIcon: menuItem.icon, onClick: menuItem.onClick }, menuItem.label)))))),
        item.delayDays && (React.createElement("div", { className: styles.aside },
            item.delayDays,
            " ",
            t('days')))));
}
export default TimelineEvent;
